import React, { useEffect, useCallback, useState } from "react";
import styled from "styled-components";
import PowerGoAndSubheader from "../../../components/SignUpLoginForgot/PowerGoAndSubheader";
import Button from "../../../components/Button";
import LabelLink from "../../../components/SignUpLoginForgot/LabelLink";
import { Colors, Text } from "../../../config";
import { useNavigate } from "react-router-dom";
import LineWithOrText from "./LineWithOrText";
import {
  FlexWithGap,
  LoginLayout,
  WidthWrapper,
} from "../../../components/SignUpLoginForgot/LoginStyledComponents";
import MicrosoftImageAndTitle from "./MicrosoftImageAndTitle";
import { useMsal } from "@azure/msal-react";
import { aadLogin, tokenRegister } from "../../../services/userServices";
import { useLoaderContext } from "../../../contexts/loaderContext";
import ErrorModal from "../../../components/ErrorSuccessModal/ErrorModal";
// import { requestForToken } from "../../../firebaseNotifications/firebase";
import Onboarding from "../../../components/Onboarding";

const loginPIHlogo = require("../../../assets/images/logo_PIH.png");
const flightLogo = require("../../../assets/images/flightLogin_white.png");
const employeeLogin = require("../../../assets/images/emp_icon_blue.png");
// const employeeLogin = require("../../../assets/images/login_employeeID.png");

const Login = () => {
  let navigate = useNavigate();
  const { instance } = useMsal();
  const { setLoader } = useLoaderContext();
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const [firstLaunch, setFirstLaunch] = useState(null);


  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  const triggerLogin = useCallback(async () => {
    setLoader(true);
    try {
      const response = await instance.loginPopup();
      let res = await aadLogin(response?.account?.username, response?.uniqueId);
      // let responseToken = await requestForToken();

      localStorage.setItem("token", res?.data?.token);
      localStorage.setItem("roleEmployee", "employee");
      localStorage.setItem("userId", res?.data?.userId);
      localStorage.setItem("shownTutorial", res?.data?.isVideoViewed);
      localStorage.setItem("employeeData", JSON.stringify({ ...res?.data }));
      setLoader(false);
      // await tokenRegister({ token: responseToken });
      // localStorage.setItem("firebaseEmployeeToken", responseToken);
      navigate("/user/dashboard");
    } catch (err) {
      setLoader(false);
      setBackendErrorMsg(err.message);
    }
  }, [instance]);

  const handleEmployeeLogin = () => {
    navigate("/auth/login/employee");
  };
  const handleSignUp = () => {
    navigate("/auth/signup");
  };

  useEffect(() => {
    const appData = localStorage.getItem("appLaunched");
    console.log("appdata", appData);
    setFirstLaunch(appData === "false" || appData === null ? true : false);
  }, []);

  return (
    <>
      {firstLaunch ? (
        <Onboarding onGetStarted={() => setFirstLaunch(false)} />
      ) : (
        <LoginLayout>
          <LoginInnerWrapper>
            <TopWrapper>
              <ImgResponsivePIH src={loginPIHlogo} alt="PIH_logo" />
              <PowerGoAndSubheader />
              <div>
                <MicrosoftImageAndTitle />
                <WidthWrapper maxWidth="22.5rem">
                  <Button
                    label={Text.login}
                    onClick={triggerLogin}
                    rightImgSrc={flightLogo}
                    fontColor={Colors.white}
                    fontSize="1.375rem"
                    fontWeight="700"
                    bgColor={Colors.brandTwo}
                    topBottomPadding="0.8rem"
                    labelImgGap="0.5rem"
                  />
                </WidthWrapper>
              </div>
            </TopWrapper>
            <FlexWithGap gap="1.5rem">
              <LineWithOrText />
              <LabelLink
                labelText={Text.dontHaveCompanyEmail}
              />
              <WidthWrapper maxWidth="22.5rem">
                <Button
                  label={Text.loginWithEmployeeID}
                  onClick={handleEmployeeLogin}
                  rightImgSrc={employeeLogin}
                  fontColor={Colors.brandTwo}
                  fontSize="1.125rem"
                  fontWeight="400"
                  bgColor={Colors.transparent}
                  outlineColor={Colors.brandTwo}
                  topBottomPadding="0.8rem"
                  labelImgGap="0.75rem"
                />
              </WidthWrapper>
           
            </FlexWithGap>
          </LoginInnerWrapper>
          {backendErrorMsg && (
            <ErrorModal
              subheaderText={backendErrorMsg}
              setClose={closeErrorModal}
              onButtonClick={closeErrorModal}
            />
          )}
        </LoginLayout>
      )}
    </>
  );
};

export default Login;

const LoginInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 90%;
  justify-content: space-between;
`;
const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 70%;
  justify-content: space-between;
`;
const ImgResponsivePIH = styled.img`
  height: auto;
  max-width: 100%;
  @media only screen and (max-width: 500px), screen and (max-height: 780px) {
    width: 11rem;
    height: 6.125rem;
  }
`;
